export default __webpack_public_path__ + "static/media/edit_btn.6afc6a55.svg";